import { API_BASE_URL } from "../../../constants";
import { LOGIN_SUCCESS, LOGIN_FAIL, API_ERROR } from "./actionTypes";
import axios from "axios";

// Enable credentials globally (for Laravel Sanctum authentication)
axios.defaults.withCredentials = true;

// 🔹 Login Action
export const loginUser = (credentials, navigate) => async (dispatch) => {
    try {
        // Step 1: Get CSRF token (only if required by Laravel Sanctum)
        await axios.get(`${API_BASE_URL}/sanctum/csrf-cookie`);

        // Step 2: Perform login
        const response = await axios.post(`${API_BASE_URL}/login`, credentials);
        const { status, user, token } = response.data;

        if (status === "success" && token) {
            // Step 3: Store token & user details in localStorage
            localStorage.setItem("token", token);
            localStorage.setItem("user", JSON.stringify(user));

            // Step 4: Set Authorization header for future requests
            axios.defaults.headers.common["Authorization"] = `Bearer ${token}`;

            // Dispatch login success
            dispatch({ type: LOGIN_SUCCESS, payload: user });

            // ✅ Step 5: Handle multiple roles correctly
            const userRoles = user.type ? user.type.split(",") : [];

            if (userRoles.includes("admin")) {
                navigate("/admin/dashboard");
            } else if (userRoles.includes("staff")) {
                navigate("/staff/dashboard");
            }
            else {
                navigate("/login"); // Default redirect
            }
        } else {
            throw new Error("Invalid login response");
        }

    } catch (error) {
        dispatch({
            type: LOGIN_FAIL,
            payload: error.response?.data?.message || "Invalid credentials",
        });
    }
};

// 🔹 Logout Action
export const logoutUser = (navigate) => async (dispatch) => {
    try {
        const token = localStorage.getItem("token");

        // Attempt API logout only if token exists (optional)
        if (token) {
            try {
                await axios.post(
                    `${API_BASE_URL}/logout`,
                    {},
                    {
                        headers: { Authorization: `Bearer ${token}` },
                        withCredentials: true,
                    }
                );
            } catch (apiError) {
                console.error("Logout API failed (proceeding anyway):", apiError.response?.data || apiError);
            }
        }

        // Always clear local data and redirect
        localStorage.removeItem("token");
        localStorage.removeItem("user");
        delete axios.defaults.headers.common["Authorization"];

        // Optional: Reset Redux state (if using Redux)
        dispatch({ type: 'USER_LOGGED_OUT' });

        // Force redirect to login (even if token was missing)
        navigate("/login", { replace: true });

    } catch (error) {
        // Fallback cleanup in case of unexpected errors
        localStorage.removeItem("token");
        localStorage.removeItem("user");
        delete axios.defaults.headers.common["Authorization"];
        navigate("/login", { replace: true });
        console.error("Unexpected logout error:", error);
    }
};

// 🔹 API Error Action
export const apiError = (message) => ({
    type: API_ERROR,
    payload: message,
});